import { useState } from 'react';
import { RoleType, RoleTypeMap } from '@/constants';

export interface UseCollapseOptions {
  defaultActiveKey?: RoleType;
  onChange?: (key: RoleType) => void;
}

export const useCollapse = ({
  defaultActiveKey = RoleType.Seller,
  onChange,
}: UseCollapseOptions) => {
  const [active, setActive] = useState(defaultActiveKey);
  const handleChange = (key: string) => {
    const roleType = RoleTypeMap[key];
    if (active !== roleType) {
      setActive(roleType);
      onChange?.(roleType);
    }
  };

  return {
    active,
    handleChange,
  };
};
